/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const UNLOADING_TRUCK_COLUMNS = [
  { id: "created_at", label: "Date", accessorKey: "created_at", filterType: "date", sortable: true },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "code", label: "Code", accessorKey: "code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  { id: "assigned_to", label: "Assigned", accessorKey: "assigned_to", filterType: "text" },
  {
    id: "state",
    label: "State",
    accessorKey: "state",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "APPROVED", label: "Approved" },
      { value: "UNLOADING", label: "Unloading" },
      { value: "WEIGH_MID", label: "Weigh mid" },
      { value: "UNLOADING_HOLD", label: "On hold" },
    ],
    matchFilter: (row, value) => !value || row.state === value,
  },
];

/** Unloading register tab — recorded unload assignments. */
export const UNLOADING_REGISTER_COLUMNS = [
  {
    id: "created_at",
    label: "Unload date",
    accessorKey: "created_at",
    sortable: true,
    filterable: false,
    exportValue: (row) => (row.created_at || "").replace("T", " ").slice(0, 19),
  },
  {
    id: "date_from",
    label: "Unload from",
    filterType: "date",
    hideInTable: true,
  },
  {
    id: "date_to",
    label: "Unload to",
    filterType: "date",
    hideInTable: true,
  },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "purchase_code", label: "Purchase", accessorKey: "purchase_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  {
    id: "locations",
    label: "Locations",
    accessor: (row) => (row.destinations || []).map((d) => d.location_id).filter(Boolean).join(", ") || "—",
    filterType: "text",
  },
  {
    id: "total_bags",
    label: "Bags",
    accessorKey: "total_bags",
    filterType: "text",
    sortable: true,
    render: (row) => row.total_bags ?? "—",
  },
  {
    id: "total_weight_qtl",
    label: "Qtl",
    accessorKey: "total_weight_qtl",
    filterType: "text",
    sortable: true,
    render: (row) => (row.total_weight_qtl != null ? row.total_weight_qtl : "—"),
  },
  {
    id: "labour_contractor_name",
    label: "Unloaded by",
    accessorKey: "labour_contractor_name",
    filterType: "text",
    render: (row) => row.labour_contractor_name || "—",
  },
  { id: "created_by", label: "By", accessorKey: "created_by", filterType: "text" },
  {
    id: "destinations",
    label: "Dest detail",
    accessor: (row) =>
      (row.destinations || [])
        .map((d) => `${d.location_id} ${d.bags || ""} ${d.weight_qtl || ""}`)
        .join(" "),
    filterType: "text",
    hideInTable: true,
  },
  {
    id: "purchase_id",
    label: "Purchase ID",
    accessor: (row) => String(row.purchase_id ?? ""),
    filterType: "text",
    hideInTable: true,
  },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const UNLOAD_LOG_COLUMNS = [
  {
    id: "purchase_id",
    label: "Purchase",
    accessor: (row) => String(row.purchase_id ?? ""),
    filterType: "text",
  },
  {
    id: "destinations",
    label: "Locations",
    accessor: (row) =>
      (row.destinations || [])
        .map((d) => `${d.location_id} ${d.variety || ""} ${d.bags || ""} ${d.weight_qtl || ""}`)
        .join(" "),
    filterType: "text",
  },
  { id: "created_by", label: "By", accessorKey: "created_by", filterType: "text" },
  { id: "created_at", label: "When", accessorKey: "created_at", filterType: "date" },
];
